import {combineReducers} from 'redux'
import login from '../login'
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    clb: combineReducers({
        ...login.reducers
    })
}
